<script>
//站点基础信息配置
const siteName='牛油果网';
const siteLabel='云果网旗下平台';
//const siteTabId=934;
const siteTabId=930;
//const siteApiDomain='https://www.gaoyuanyunguo.com';
const siteApiDomain='';
const resourceDomain='https://gyyg.oss-cn-shenzhen.aliyuncs.com';
const siteApi={
  'hyzx_list':'/api/article/newsList',
  'hyzx_detail':'/api/article/detail',
};
const pageSize=20;
const pageNumber=1;
const pageTotal=1;
var siteDefaultNav='首页';
//站点风格样式配置
const themestyle={
  fontSizeI:'12px',
  fontSizeII:'14px',
  fontSizeIII:'16px',
  fontSizeIIII:'18px',
  colorA:'#598118',
  colorB:'#BE550F',
  colorC:'#68352F-#BE550F',
  colorD:'#598118-#D1DA4D',
  colorE:'#598118-#BE550F',
  colorF:'#F1A100',
  colorG:'#477931',
}
//站点固定连接
const mainServiceList=[
{title:'集配中心',label:'WAREHOUSING SERVICE',icon:'service1_',link:'/cyfw/detail/11',class:'style-1'},
{title:'分选加工',label:'SORTING SERVICE',icon:'service2_',link:'/cyfw/detail/9',class:'style-2'},
{title:'直播基地',label:'LIVE BASE',icon:'service3_',link:'/cyfw/detail/10',class:'style-3'}
]

const dataServiceList=[
{title:'产业报告',label:'仓储物流企业 仓配服务 物流需求 物流供应 好仓推荐 仓库需求',icon:'service_icon_1.png',link:'/jrkjfw',class:'style-1'},
{title:'行业内参',label:'仓储物流企业 仓配服务 物流需求 物流供应 好仓推荐 仓库需求',icon:'service_icon_2.png',link:'/jrkjfw/kjfw',class:'style-2'},
{title:'孟连牛油果',label:'孟连县发展牛油果种植3万亩，培育产业主体23个，覆盖5个乡(镇)。',icon:'service_icon_3.png',link:'/jrkjfw/zjfw',class:'style-3',
'remark':'孟连县于2007年开始引种试种牛油果，通过近8年的试验示范，2019年,全县 牛油果投产面积4000亩，总产量2000吨，实现农业总产值0.45亿元。孟连县获批为牛油果产业“一 县- -业” 特色县。截止2020年111，全县已发展牛油果种植3万亩，培育产业主体23个，覆盖5个乡(镇)10个深度贫困村62个村民小组1284户建档立卡户3852人。'},
{title:'孟连牛油果--backup',label:'孟连县牛油果种植分布在xx、xxxx以及xx',icon:'service_icon_3.png',link:'/jrkjfw/zjfw',class:'style-3',
'remark':'截止2020年5月，孟连牛油果种植面积已突破xx万亩，涉及农户xx余家，预计2020年总产量将达xx万吨，预估总产值xx亿元。孟连是目前全国种植面积最大、品质最好的牛油果规模化种植核心区，是全国连片种植规模最大的牛油果种植基地'}
]
//科技服务固定数据
const kjfwServiceList=[{title:'种植服务','link':'/jrkjfw/zzjs','style':'data-ico-zz',label:'依托30年历史作物生长数据，整合地形、气象等多元数据，实现对任一农户进行专家咨询服务，为农业提供量化依据。'}]
const kjfwServiceFlow=[
{order:'01',title:'选择专家',label:'CHOOSE EXPERT','link':'',content:'请根据您种植的药材品种、种植面积等实际情况，选择合适的专家。'},
{order:'02',title:'预约挂号',label:'BOOKING REGISTER','link':'',content:'我们根据专家级别进行差异化定价，以保证您的需求和专家资源有序匹配。'},
{order:'03',title:'在线支付',label:'ONLINE PAYMENT','link':'',content:'您可以在线支付专家预约费，支持支付宝和微信等在线支付方式，安全便捷。'},
{order:'04',title:'签订合同',label:'SIGN A CONTRACT','link':'',content:'客服人员根据通过和双方的充分沟通，拟定并协调双方签订服务合同（签订年服务合同或单次服务合同）。'},
{order:'05',title:'实地指导',label:'THE FIELD GUIDE','link':'',content:'专家根据服务合同中的相关约定，为客户提供一对一的实地上门服务。'},
{order:''}]
//站点演示数据
const newsListDemo=[
  {
    id:'1',
    title:'马来西亚不止有猫山王榴莲1',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片1,作为一个榴莲小编,要设置整个div的背景为一张图片1,作为一个榴莲小编,要设置整个div的背景为一张图片1',
    date:'2021-04-21',
    imgUrl:"url('https://img0.baidu.com/it/u=3384913163,1256852657&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'2',
    title:'马来西亚不止有猫山王榴莲2',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片2',
    date:'2021-04-22',
    imgUrl:"url('https://img2.baidu.com/it/u=2727617481,724178111&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'3',
    title:'马来西亚不止有猫山王榴莲3',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片3',
    date:'2021-04-23',
    imgUrl:"url('https://img1.baidu.com/it/u=3903181357,1976828476&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'4',
    title:'马来西亚不止有猫山王榴莲4',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片4',
    date:'2021-04-24',
    imgUrl:"url('https://img0.baidu.com/it/u=999162580,4157174907&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'5',
    title:'马来西亚不止有猫山王榴莲5',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片5',
    date:'2021-04-25',
    imgUrl:"url('https://img2.baidu.com/it/u=1515461392,825794707&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'6',
    title:'马来西亚不止有猫山王榴莲6',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片1',
    date:'2021-04-21',
    imgUrl:"url('https://img0.baidu.com/it/u=3384913163,1256852657&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'7',
    title:'马来西亚不止有猫山王榴莲7',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片2',
    date:'2021-04-22',
    imgUrl:"url('https://img2.baidu.com/it/u=2727617481,724178111&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'8',
    title:'马来西亚不止有猫山王榴莲8',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片3',
    date:'2021-04-23',
    imgUrl:"url('https://img1.baidu.com/it/u=3903181357,1976828476&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'9',
    title:'马来西亚不止有猫山王榴莲9',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片4',
    date:'2021-04-24',
    imgUrl:"url('https://img0.baidu.com/it/u=999162580,4157174907&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
  {
    id:'10',
    title:'马来西亚不止有猫山王榴莲10',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片5',
    date:'2021-04-25',
    imgUrl:"url('https://img2.baidu.com/it/u=1515461392,825794707&fm=26&fmt=auto&gp=0.jpg')",
    goto:'/'
  },
];

const imgInfoList=[{
    id: '1',
    title: '金融服务1',
    label: 'FINANCIAL SERVICES',
    imgUrl: "url('https://img0.baidu.com/it/u=3384913163,1256852657&fm=26&fmt=auto&gp=0.jpg')",
    goto: '/'
  },
  {
    id: '2',
    title: '科技服务2',
    label: 'TECHNOLOGY SERVICE',
    imgUrl: "url('https://img2.baidu.com/it/u=2727617481,724178111&fm=26&fmt=auto&gp=0.jpg')",
    goto: '/'
  },
  {
    id: '3',
    title: '专家服务3',
    label: 'EXPERT SERVICES',
    imgUrl: "url('https://img1.baidu.com/it/u=3903181357,1976828476&fm=26&fmt=auto&gp=0.jpg')",
    goto: '/'
  },
];

const imgInfoList2=[{
    id: '1',
    title: '金融服务1',
    label: 'FINANCIAL SERVICES',
    imgUrl: 'https://img0.baidu.com/it/u=3384913163,1256852657&fm=26&fmt=auto&gp=0.jpg',
    goto: '/'
  },
  {
    id: '2',
    title: '科技服务2',
    label: 'TECHNOLOGY SERVICE',
    imgUrl: 'https://img2.baidu.com/it/u=2727617481,724178111&fm=26&fmt=auto&gp=0.jpg',
    goto: '/'
  },
  {
    id: '3',
    title: '专家服务3',
    label: 'EXPERT SERVICES',
    imgUrl: 'https://img1.baidu.com/it/u=3903181357,1976828476&fm=26&fmt=auto&gp=0.jpg',
    goto: '/'
  },
  {
    id:'4',
    title:'马来西亚不止有猫山王榴莲8',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片3',
    date:'2021-04-23',
    imgUrl:'https://img1.baidu.com/it/u=3903181357,1976828476&fm=26&fmt=auto&gp=0.jpg',
    goto:'/'
  },
  {
    id:'5',
    title:'马来西亚不止有猫山王榴莲9',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片4',
    date:'2021-04-24',
    imgUrl:'https://img0.baidu.com/it/u=999162580,4157174907&fm=26&fmt=auto&gp=0.jpg',
    goto:'/'
  },
  {
    id:'6',
    title:'马来西亚不止有猫山王榴莲10',
    label:'作为一个榴莲小编,要设置整个div的背景为一张图片5',
    date:'2021-04-25',
    imgUrl:'https://img2.baidu.com/it/u=1515461392,825794707&fm=26&fmt=auto&gp=0.jpg',
    goto:'/'
  },
];

const newsDetail={
    id: '1',
    title: '云南北移亚洲象群小范围活动 独象返回晋宁区,记者从云南北移亚洲象群安全防范工作省级指挥部了解到',
    label: '6月20日在玉溪市峨山县大龙潭乡拍摄的象群（无人机照片）',
    publisher:'中国新闻网',
    date:'2021-06-01',
    visits:'134',
    imgUrl: 'https://rs-channel.huanqiucdn.cn/imageDir/5e9873efcf39e507cb4674460528b123.jpg',
    content: '6月20日在玉溪市峨山县大龙潭乡拍摄的象群（无人机照片）。记者从云南北移亚洲象群安全防范工作省级指挥部了解到，6月19日18时至6月20日18时，北移象群动态整体平稳，持续在玉溪市峨山县大龙潭乡280米范围内迂回移动。独象从安宁市返回晋宁区，在晋宁区双河乡附近林地内活动，距离象群24.3公里。15头北移亚洲象均在监测范围内，人象平安。 新华社发 云南省森林消防总队供图。县委书记丁洪涛作讲话'+
'丁洪涛指出'+
'年内要成功创建国家卫生县城，是省、州下达给我们的军令状，也是我们从提升巍山形象，打造民生福祉出发，主动参与的一场全省创卫大决战，只许成功，不许失败。前期各乡镇和各创建单位认真落实工作，以找差距、补短板、主攻关键部位、加强薄弱环节为重点，解决了创建工作中的不少突出问题。但从7月初，县创卫工作领导小组办公室开展的全面自检自查情况来看，工作中仍然存在一些不可忽视的问题，一是思想认识不到位，对创卫工作重视不够。二是各类专项整治不彻底，出现反弹回潮。三是硬件设施不完备，城市管理不精细。四是创建氛围不浓厚，档案管理不规范等。'+
'丁洪涛要求'+
'要全面落实整改，以锲而不舍的精神、攻坚克难的作风抓实创卫工作。进一步压实责任，加快问题清零。县创卫办要强化统筹协调和业务指导，加大工作督查的力度和频次，要善于发现问题，敢于亮出问题，采取现场交办、书面交办等形式，把存在问题一项一项清零，确保所有指标都能达标。'+
'丁洪涛强调'+
'创卫每一项指标都是硬要求、硬杠杠，时间紧、任务重，这不仅是对全县人居环境的严格考评，更是对全县各级干部的工作能力和作风的深入检验。必须以严明的责任、严格的督查、严肃的纪律作保障。',
    previous:'我国累计报告接种新冠病毒疫苗超16亿剂次',
    previousUrl:'/',
    next:'北京新增2例京外疫情关联新冠肺炎确诊病例 均为张家界返京人员',
    nextUrl:'/',
  };

export default {
  siteName,
  siteLabel,
  siteDefaultNav,
  siteTabId,
  siteApiDomain,
  resourceDomain,
  siteApi,
  mainServiceList,
  dataServiceList,
  kjfwServiceList,
  kjfwServiceFlow,
  newsListDemo,
  imgInfoList,
  newsDetail,
  imgInfoList2,
}
</script>



// WEBPACK FOOTER //
// src/components/utils/Global.vue